import { Immutable } from "immer";
import React from "react";

import { ValuePropBarBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ValuePropsBar } from "../ValuePropsBar";
import { getSpacingClasses } from "../_spacing/spacing";

export const ValuePropsBarBlock = (
    props: Immutable<{
        valuePropsData: ValuePropBarBlock;
    }>,
): React.ReactNode => {
    const valueProps = props.valuePropsData.value_props ?? [];
    return (
        <div
            className={concatClassNames([
                "value-prop-bar-block",
                "value-props-bar-block",
                props.valuePropsData.background_style?.style ?? "",
                props.valuePropsData.responsive_visibility?.visibility ?? "",
                props.valuePropsData.spacing
                    ? getSpacingClasses(props.valuePropsData.spacing)
                    : "",
            ])}
        >
            <ValuePropsBar valueProps={valueProps} />
        </div>
    );
};
